import {Component, OnInit} from '@angular/core';
import {routerTransition} from '@app/router.animations';
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {CommonModule, DatePipe} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {UtilsInjectable} from '@app/shared';
import {provideNgxMask} from 'ngx-mask';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    SelectDropDownModule
  ],
   providers: [DatePipe, provideNgxMask()]
})
export class PaymentComponent implements OnInit {

  public date: any;
  public user_rights: any = {};
  public user_data: any = {};
  public vendor_options: any;
  public vendor_data: any;
  public payment_list: any;
  public invoices_list: any[] = [];
  public total_adjusted = 0;
  public payment: any =
    {
      payment_no: '',
      supplier_data: '',
      vendor_id:0,
      payment_type: 'Cash',
      payment_date: new Date(),
      payment_amount: '',
      edit_status:0,
    }
 
    constructor(
        private loaderService: LoaderService, 
        public consultingService: ConsultingService, 
        private toastr: ToastrService,
        protected utils: UtilsInjectable,
    ) {}

    ngOnInit() {
        this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
        this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
        this.getDropdowns();
        if(!this.payment.edit_status){
            this.getPaymentNo();
        }
        this.getPaymentlist();
    }

    getPaymentNo(){
        this.consultingService.getPaymentNo().subscribe((result: any) => {
             if (result['status'] == 'Success') {
                this.payment.payment_no = result['payment_no'];
             }
        });
    }

    getPaymentlist(){
        this.consultingService.getPaymentList().subscribe((result: any) => {
            if (result['status'] == 'Success') {
            this.payment_list = result['data'];
            }
        });
    }

    getDropdowns() {
        const postData = {
            vendor_id: ''
        }
        this.loaderService.display(true);
        this.consultingService.listVendor(postData).subscribe((result: any) => {
        this.loaderService.display(false);
        if (result['status'] == 'Success') {
            this.vendor_options = result['data'];
            for (let index = 0; index < this.vendor_options.length; index++) {
            if (this.vendor_options[index].VENDOR_ID == this.payment.vendor_id) {
                this.vendor_data = this.vendor_options[index];
            }
            }
        }
        });
    }

    clearPaymnet(){
        this.payment.payment_no = '';
        this.payment.vendor_data='';
        this.payment.vendor_id = 0;
        this.payment.payment_type = 'Cash';
        this.payment.payment_date= new Date();
        this.payment.payment_amount = '';
        this.payment.edit_status = 0;
        this.total_adjusted = 0;
        this.invoices_list = []
    }

    clear(){
        this.clearPaymnet();
        this.getPaymentNo();
    }

    getVendor(data: any) {
        if (data['value']) {
            this.payment.vendor_id = data['value'].VENDOR_ID;
            this.payment.vendor_data = data['value'].VENDOR_NAME;
        }

        if(!this.payment.vendor_id) return;
        const postData = { vendor_id: this.payment.vendor_id };
        this.loaderService.display(true);
        this.consultingService.listVendorPurchaseInvoices(postData).subscribe((res: any) => {
            this.loaderService.display(false);
            if(res.status === 'Success' && res.data.length){
                this.invoices_list = res.data.map((inv:any) => ({
                    ...inv,
                    adjust_amount: 0,
                    checked: false
                }));
            } else {
                this.invoices_list = [];
                this.toastr.warning('No invoices found for this supplier.');
            }
        });

    }

    recalculateTotal() {
        this.total_adjusted = this.invoices_list.reduce((sum, inv) => inv.checked ? sum + (Number(inv.adjust_amount) || 0) : sum, 0);
    }

    getTotalBalance() {
        return this.invoices_list.reduce((sum, inv) => sum + (Number(inv.NET_TOTAL - inv.ADJUSTED_AMOUNT) - (Number(inv.adjust_amount) || 0)), 0);
    }

    autoDistributeAmount() {
        let remaining = Number(this.payment.payment_amount) || 0;
        this.invoices_list.forEach(inv => {
            inv.checked = false;
            inv.adjust_amount = 0;
            if(remaining > 0){
                const available = Number(inv.NET_TOTAL);
                const adjust = Math.min(available, remaining);
                inv.adjust_amount = adjust;
                inv.checked = true;
                remaining -= adjust;
            }
        });
        this.recalculateTotal();
    }

    selectPaymentType(type: any){
        this.payment.payment_type = type;
    }

    public getToday(): string {
        return new Date().toISOString().split('T')[0]
    }

    numberOnly(event: KeyboardEvent): boolean {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
            return false;
        }
        return true;
    }

    savePayment(){
        if(!this.payment.vendor_id){
            this.toastr.error('Please Select a Supplier !');
            return;
        }else if(!this.payment.payment_type){
            this.toastr.error('Please Choose Payment TYpe !');
            return;
        }else if(!this.payment.payment_date){
            this.toastr.error('Please Select Date !');
            return;
        }else if(!this.payment.payment_amount){
            this.toastr.error('Please Enter Amount !');
            return;
        }else{

            if(this.invoices_list.some(inv => inv.checked && inv.adjust_amount > 0)){
                const adjustedInvoices = this.invoices_list
                    .filter(inv => inv.checked && inv.adjust_amount > 0)
                    .map(inv => ({ invoice_id: inv.PURCHASE_ID, adjust_amount: inv.adjust_amount }));

                const payload = {
                    ...this.payment,
                    adjusted_invoices: adjustedInvoices
                };

                this.loaderService.display(true);
                this.consultingService.savePayment(payload).subscribe((result: any) => {
                    if (result["status"] == "Success") {
                        this.invoices_list = [];
                        this.clearPaymnet();
                        this.getPaymentNo();
                        this.getPaymentlist();
                        this.loaderService.display(false);
                        this.toastr.success(result.msg);
                    }else{
                        this.loaderService.display(false);
                        this.toastr.error(result.msg);
                    }
                });
            }else{
                this.toastr.error('Please select at least one invoice with a valid adjust amount.');
                return;
            }


        }
    }

    edit_payment(data: any){
        window.scrollTo(0, 0)

        this.payment.edit_status = 1;
        this.payment.payment_no = data.PAYMENT_NO;
        this.payment.vendor_data= data.VENDOR_NAME;
        this.payment.vendor_id = data.PAYMENT_VENDOR;
        this.payment.payment_type = data.PAYMENT_TYPE;
        const parts =  data.FORMATED_DATE.split('-');
        this.payment.payment_date = new Date(+parts[2], +parts[1]-1, +parts[0]);
        this.payment.payment_amount = data.PAYMENT_AMOUNT;
        this.payment.payment_id = data.PAYMENT_ID;
    }

    delete_payment(id: any){
        const confirmed = window.confirm("Are you sure you want to delete this payment?");
        if(confirmed){
            this.loaderService.display(true);
            this.consultingService.deletePayment({paymentid:id}).subscribe((result: any) => {
            if (result["status"] == "Success") {
                this.getPaymentlist();
                this.loaderService.display(false);
                this.toastr.success(result.msg);
            }else{
                this.loaderService.display(false);
                this.toastr.error(result.msg);
            }
        });
        }
    }
}
